export interface SplitTicketQuotesResult {
  quotesHtml: string;
  quoteBlocks: string[];
  editorHtml: string;
}

/**
 * Separates ticket quote blockquotes from the editable editor HTML so quotes
 * can live outside the Quill root without being normalised away.
 */
export function splitTicketQuotesFromEditorHtml(
  html: string
): SplitTicketQuotesResult {
  if (!html.includes('data-quote-source')) {
    return { quotesHtml: '', quoteBlocks: [], editorHtml: html };
  }

  const doc = new DOMParser().parseFromString(
    `<div data-editor-root="1">${html}</div>`,
    'text/html'
  );
  const root = doc.querySelector('[data-editor-root="1"]');
  if (!root) {
    return { quotesHtml: '', quoteBlocks: [], editorHtml: html };
  }

  const quotes = [
    ...root.querySelectorAll(
      'blockquote[data-quote-source], blockquote.ticket-quote'
    )
  ];
  const quoteBlocks: string[] = quotes.map((quote: Element) => quote.outerHTML);
  const quotesHtml = quoteBlocks.join('');

  for (const quote of quotes) {
    quote.remove();
  }

  return {
    quotesHtml,
    quoteBlocks,
    editorHtml: root.innerHTML.trim()
  };
}
